import { injectable } from "inversify";
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from "@xlearn/common";
import * as Api from "@/app/state-serialization/api";
import { GroupingAnswer, GroupingAnswerGroupMember } from "./grouping-interfaces";
import { ProtobufSerializer } from "@/app/state-serialization/infrastructure";

interface GroupingGroupMember {
  key: string;
  val: string[];
}

@injectable()
export class GroupingQuestionAnswerProtobufSerializer
  implements Api.StateSerializationPlugin<GroupingAnswer> {
  key = {
    id: 16,
    name: { ns: "suspend-data", name: "question-answer-grouping" },
    format: "protobuf"
  };

  serialize(data: GroupingAnswer): Result<Uint8Array, Api.SerializerError> {
    const groupMembers: GroupingGroupMember[] = [];

    for (let i in data.groupMembers) {
      groupMembers.push({
        key: i,
        val: data.groupMembers[i],
      })
    }

    const message = new GroupingAnswerProtoMessage({
      groupMembers,
    });

    return ProtobufSerializer.serialize<GroupingAnswerProtoMessage>(
      message,
      GroupingAnswerProtoMessage
    );
  }

  deserialize(
    content: Uint8Array
  ): Result<GroupingAnswer, Api.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<
      GroupingAnswerProtoMessage
    >(content, GroupingAnswerProtoMessage);
    if (!deserializeResult.success) {
      return deserializeResult;
    }

    const groupMembers: GroupingAnswerGroupMember = {};
    const message = deserializeResult.value;
    message.groupMembers.forEach(member => groupMembers[member.key] = member.val);

    const result: GroupingAnswer = {
      groupMembers,
    };

    return ok(result);
  }
}

@Type.d("GroupingAnswerGroupMemberProtoMessage")
export class GroupingAnswerGroupMemberProtoMessage extends Message<GroupingAnswerGroupMemberProtoMessage> {
  @Field.d(1, "string", "optional", "")
  key: string;

  @Field.d(2, "string", "repeated")
  val: string[];
}

@Type.d("GroupingAnswerProtoMessage")
class GroupingAnswerProtoMessage extends Message<GroupingAnswerProtoMessage> {
  @Field.d(1, GroupingAnswerGroupMemberProtoMessage, "repeated")
  groupMembers: GroupingGroupMember[];
}
